/**
 * @desc 根据itemID生成对应包裹
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.CreatePackageToItemIdRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/backdoor/createPackageToItemId`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
